<script>
import { ref } from "vue";
import useVuelidate from "@vuelidate/core";
import DropZone from "@/components/widgets/dropZone";
import datepicker from "vue3-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Criar Nova Postagem",
    meta: [{ name: "description", content: appConfig.description }],
  },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0];
    };
    return { dropzoneFile, drop, selectedFile, v$: useVuelidate() };
  },
  components: {
    DropZone,
    datepicker,
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      updating: true,
      title: "Criar Nova Postagem",
      items: [
        {
          text: "Postagens",
          href: "/postagens/list",
        },
        {
          text: "Criar Nova Postagem",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      daterange: ref(new Date()),
    };
  },
  mounted() {
    console.log('mounted postagem-editar_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
  methods: {

    abrirAdCreative(){
      console.log('abrirAdCreative')
      window.open('https://pt.adcreative.ai/', '_blank');
    },

    abrirManyContent(){
      console.log('abrirManyContent')
      window.open('https://manycontent.com/', '_blank');
    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="abrirAdCreative" >
                <i class="bx bx-layer font-size-16 align-middle me-2"></i>
                Ad. Creative
              </b-button>

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimirOrcamento">-->
              <!--                <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
              <!--                Imprimir-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento"  >-->
              <!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
              <!--                Cancelar Orçamento-->
              <!--              </b-button>-->

              <b-button variant="outline-warning" class="mx-2" @click="abrirManyContent" >
                <i class="bx bx-git-pull-request font-size-16 align-middle me-2"></i>
                Many Content
              </b-button>

            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Criar Nova Postagem</h4>
            <form>
              <div class="form-group row mb-4">
                <label for="projectname" class="col-form-label col-lg-2"
                >Nome</label
                >
                <div class="col-lg-10">
                  <input
                      id="projectname"
                      name="projectname"
                      type="text"
                      class="form-control"
                      placeholder="Entrar com nome do post..."
                  />
                </div>
              </div>
              <div class="form-group row mb-4">
                <label for="projectdesc" class="col-form-label col-lg-2"
                >Descrição</label
                >
                <div class="col-lg-10">
                  <textarea
                      id="projectdesc"
                      class="form-control"
                      rows="3"
                      placeholder="Entrar com descrição do post..."
                  ></textarea>
                </div>
              </div>

              <div class="form-group row mb-4">
                <label for="dataInicio" class="col-form-label col-lg-2">Data de Início</label>
                <div class="col-lg-10">
                  <datepicker
                      id="dataInicio"
                      class="form-control"
                      v-model="daterange"
                      range
                      append-to-body
                      lang="en"
                      confirm
                  ></datepicker>
                </div>
              </div>

              <div class="form-group row mb-4">
                <label for="projectbudget" class="col-form-label col-lg-2"
                >Orçamento</label
                >
                <div class="col-lg-10">
                  <input
                      id="projectbudget"
                      name="projectbudget"
                      type="text"
                      placeholder="Entrar com o valor de orçamento..."
                      class="form-control"
                  />
                </div>
              </div>
            </form>
            <div class="row mb-4">
              <span class="col-form-label col-lg-2">Arquivos</span>
              <div class="col-lg-10">
                <DropZone @drop.prevent="drop" @change="selectedFile" />
                <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
              </div>
            </div>
            <div class="row justify-content-end text-end">
              <div class="col-lg-10">
                <button type="submit" class="btn btn-primary">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>